// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"74":"About","196":"Editor","268":"Home","393":"Card","877":"Projects","878":"Item"}[chunkId] + "." + {"74":"22203cc9","196":"0db0da11","268":"3ce9b6b2","393":"529b297e","877":"42c1ef1d","878":"60fb731b"}[chunkId] + ".chunk.js";
};